module.exports = __webpack_public_path__ + "static/media/logout.31fde1ec.png";